'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/intl-messageformat/node_modules/intl-messageformat-parser/index.js
// module id = 1462
// module chunks = 2